import styled from "styled-components";

export const ImageThumbnailLink = styled.div`
    display: inline-block;
    cursor: pointer;
`

export const ImageLarge = styled.img`
    max-width: 100%;
    max-height: 80vh;
`

export const Image = styled.img``